import React from 'react';
import bootbox from 'bootbox';
import BaseClass from '../common/baseClass';
import {menuHomeOpen} from '../Header/HeadersButtons';
import { Link } from "react-router-dom";
import '../../css/page-body.css';
import '../../css/print.css';
import '../../css/wishList.css';

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, setNewUrlState, changeValues } from "../../redux/actions";
import { wishListSelector } from "../../redux/selectors";
import store from "../../redux/store";
import { doLogout } from './logout';
import LoaderView from './loader';

const common = require('../common/common');
const env = require("../../config.js").default;

class WishList extends BaseClass {
  constructor(props){
    super(props);
    this.gotoTavola = this.gotoTavola.bind(this);
    this.state = { isListino: false, listinoVM: [], marcheVM: [], showLoader: false, checkout_data: null }
    this.checkout_url = common.get_localStorage("checkout_url");
  }

  async componentWillMount(){
    this.updateStateWithStoreProps();
    var marcheVM = await common.getAppEnabledVM();
    this.setState({ marcheVM: marcheVM })
    
    let isListino = await common.isEnabledList();
    this.setState({ listinoVM: Object.keys(window.cc.enabledList), isListino: isListino })
  }

  componentWillReceiveProps(nextProps){
    this.updateStateWithStoreProps(nextProps);
    this.setState({rerender: Math.random()});
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.updateStateWithStoreProps();
  }

  componentDidMount(props) {
    const $ = window.$;
    var ths = $('.tabellaWishList').find('thead');
    $("#wishListContainer").on('scroll', (e) => {
      if (e.target.scrollTop > ($("#contentHeadWish").height() + 35 + $("#portal-top").height())){
        ths.css('transform', 'translateY(' + (e.target.scrollTop - ($("#contentHeadWish").height() + 30 + $("#portal-top").height())) +'px)');
      }else{
        ths.css('transform', 'translateY(0px)');
      }
    });
  }

  changeQuantitaPezzi(codiceArticolo){
    const $ = window.$;
    var numeroPezzi = $(".articoloRow_"+ codiceArticolo.replace(/[.+-/_ ]/g,'_') + " .nuoviPezzi").val();
    if(numeroPezzi > 9999){
      var max = parseInt(9999);
      if (parseInt(numeroPezzi) > max) {
        numeroPezzi = 9999;
        $(".articoloRow_"+ codiceArticolo.replace(/[.+-/_ ]/g,'_') + " .nuoviPezzi").val(9999)
      }
    }

    if(numeroPezzi >= 1){
      var wishList;
      if(common.get_localStorage("wishList") && common.get_localStorage("wishList") !== "" && common.get_localStorage("wishList") !== undefined && common.get_localStorage("wishList") !== null){
        wishList = JSON.parse(common.get_localStorage("wishList"));
      }else{
        wishList = [];
        common.set_localStorage("wishList", JSON.stringify(wishList));
      }

      for (var a=0; a<wishList.length;  a++){
        if(wishList[a].carti === codiceArticolo){
          wishList[a].qpezzi = parseInt(numeroPezzi);
        }
      }
      common.set_localStorage("wishList", JSON.stringify(wishList));
      this.props.changeDatalist("wishList", wishList);
    }
  }

  removeAllArticoli(e){
    e.persist()
    common.remove_localStorage("wishList");
    this.props.changeDatalist("wishList", []);
  }

  removeArticolo(articolo){
    var wishList;
    if(common.get_localStorage("wishList") && common.get_localStorage("wishList") !== "" && common.get_localStorage("wishList") !== undefined && common.get_localStorage("wishList") !== null){
      wishList = JSON.parse(common.get_localStorage("wishList"));
    }else{
      wishList = [];
      common.set_localStorage("wishList", JSON.stringify(wishList));
    }

    var classArticolo = articolo.replace(/[.+-/_ ]/g,'_');
    var removeArticolo = false;
    for(var i=0; i<wishList.length; i++){
      if (wishList[i].carti === articolo){
        wishList.splice(i, 1);
        removeArticolo = true;
      }
    }

    const $ = window.$;
    if(removeArticolo === true){
      $(".tabellaWishList").css("overflow", "hidden");
      $(".articoloRow_" + classArticolo).addClass("slideOutRight");
      setTimeout(() =>{
        $(".articoloRow_" + classArticolo).removeClass("slideOutRight");
        common.set_localStorage("wishList", JSON.stringify(wishList));
        this.props.changeDatalist("wishList", wishList);
        $(".tabellaWishList").css("overflow", "");
      }, 1000);
    }
  }

  navInternoClick = () => {
    const $ = window.$;
    var open = true;
    if($('.Content_nav_interno').hasClass('open')){

      $("#body").removeClass('no_scrollbar');
      $('.Content_nav_interno').removeClass('fadeInDown');
      $('.Content_nav_interno').addClass('fadeOutUp');
      setTimeout(function(){$('.Content_nav_interno').removeClass('open');}, 300);
      var menuAperti = $(document).find(".elenco_voci.open");
      var menuApertiButtons = $(document).find(".bottoni_menu_link.submenuOpen");
      if(menuApertiButtons.length > 0){
        $(menuAperti).each(function(){
          $(this).height(0);
          $(this).removeClass("flipInX");
          $(this).addClass("flipOutX");
          $(this).removeClass("open");
        });
        $(menuApertiButtons).each(function(){
          $(this).removeClass("submenuOpen");
          $(".submenuPlaceHolder").height(0);
        });
      }
    }else{
      if(open){
        $('.Content_nav_interno').removeClass('fadeOutUp');
        $('.Content_nav_interno').addClass('open fadeInDown');
        $("#body").addClass('no_scrollbar');
      }
    }
  }

  printWishList(e) {
    e.preventDefault();
    window.print();
  }

  async gotoTavola(marca, modello, tavola, carti){
    menuHomeOpen(false);
    window.$(".banner_center_header>a").click();
    var params = {
      marca: marca,
      modello: modello,
      tavola: tavola,
      carti: carti,
    }

    var detailDistinta = await common.apiCall(env.BACKEND + "epc/get_draw/", "GET", {zprod: marca, cmoto: modello, ctavo: tavola}, true);
    if(detailDistinta.error === false){
      if(detailDistinta.CDIMA !== "")
        params.immagine = detailDistinta.CDIMA;
      else
        params.immagine = tavola;
      params.applicazione = carti;
      params.distintaGruppo = detailDistinta.DTTAV;
      params.distintaTavola = detailDistinta.DTAVO;
    }
    this.props.changeValues({ renewMutex: { mostraImg: false, modelli: false, tavole: true, distinta: true, applicazioni: true }, dataList: { applicazioni: [], immagineTavola: [], tavole: {}, distinta: {} }, filtersState: { telaio: "", applicazione: "", modello: "", tavola: "" } });
    this.props.setNewUrlState(params);
    return true;
  }

  saveCheckout(e, wishList){
    e.preventDefault();
    if(wishList !== undefined && wishList !== null && wishList.length > 0){
      common.apiCall(env.BACKEND + 'cart/', 'POST', {}, true)
      .then((cart) => {
        if(cart === undefined || cart.id === undefined)
          return false;
        this.setState({ checkout_data: this.checkout_url + '?cart_id=' + cart.id, showLoader: true });
        console.log("Cart", cart)
        var data = {items: []};
        for (var i = 0; i < wishList.length; i++) {
          data['items'].push({ "brand": wishList[i].marca, "part_number": wishList[i].carti, "description": wishList[i].darti, "quantity": wishList[i].qpezzi, "currency": wishList[i].cvalu, "price": wishList[i].price });
        }

        common.apiCall(env.BACKEND + 'cart/' + cart.id + '/', 'PATCH', data, true)
          .then((checkout) => {
          console.log("Checkout", checkout)
            this.removeAllArticoli(e);
            doLogout();
            let checkout_in_frame = common.get_localStorage("checkout_in_frame");
            if(common.inIframe() && !(checkout_in_frame !== undefined && checkout_in_frame !== null && checkout_in_frame)){
              window.top.location.href = this.state.checkout_data;
            } else {
              window.location.href = this.state.checkout_data;
            }
        });
      });
    }
  }

  render(props){
    const $ = window.$;
    let tot = 0;
    let nitem = 0;
    let firstValid = true;
    let priceElem = "", valuta = "";
    let localeLang = common.getLanguageLocale();
    var menuPaginaInterna = 'col-lg-8 col-md-7 col-sm-12';
    if(this.props.menuPaginaInterna)
      menuPaginaInterna = 'Content_nav_interno fadeInDown animated faster';
    if (this.state.showLoader)
      return (<LoaderView text={common.getTrad("Attendere, presto sarai reindirizzato")} url={this.state.checkout_data}></LoaderView>)
    else
      return (
        <div className={menuPaginaInterna + " Stampa"} id="wishListContainer">
          <style id='tabellaCarrelloBeforeTitle'>{ `
            .tabellaWishList td:nth-of-type(1):before{content: "` + common.getTrad("Marca") + `";}
            .tabellaWishList td:nth-of-type(2):before {content: "` + common.getTrad("Codice Articolo") + `"; }
            .tabellaWishList td:nth-of-type(3):before {content: "` + common.getTrad("Descrizione") + `"; }
            ` +
            (this.state.isListino ?
            `
            .tabellaWishList td:nth-of-type(4):before {content: "` + common.getTrad("Prezzo Unitario") + `"; }
            .tabellaWishList td:nth-of-type(5):before {content: "` + common.getTrad("Quantità") + `"; }
            .tabellaWishList td:nth-of-type(7):before {content: "` + common.getTrad("Prezzo Totale") + `"; }
            ` :
            `
            .tabellaWishList td:nth-of-type(5):before {content: "` + common.getTrad("Quantità") + `"; }
            `)
          }</style>
          <div id="WishListContent">
            <div id="contentHeadWish" className="mb-4">

              <button className="btn bottone_default homepage_nav mt-2" onClick={(e) => {this.navInternoClick()}}><i className="fas fa-chevron-left"></i> {common.getTrad("Indietro")}</button>
              <h1 id="PartsFinderTitle" style={{textAlign: "center"}} className="mb-4 mt-2">
                {common.getTrad("Parts Finder")}
              </h1>
              <h4 style={{textAlign: "center"}} className="mb-4 mt-2">
                {common.getTrad("Elenco Wish List")}
              </h4>
              <div className="clear"></div>
              <div className="col-xl-12 mt-2">
                {this.state.dataList.wishList && this.state.dataList.wishList.length > 0 ?
                    <div className='row' style={{ display: 'block' }}>
                        <button type="button" className="float-left btn bottone_default mb-3" onClick={(e) => { this.printWishList(e) }}><i className="fas fa-print"></i> {common.getTrad("Stampa la Wish List")}</button>
                        <p className="float-right d-print-none text-danger" id="btnSvuotaCarrello" style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            bootbox.confirm({
                              message: common.getTrad("L'azione rimuoverà in modo definitivo tutti gli articoli presenti in elenco.<br><b>Si è sicuri di voler rimuovere la wish list?</b>"),
                              buttons: {
                                confirm: {
                                  label: common.getTrad('Si'),
                                  className: 'btn bottone_default'
                                },
                                cancel: {
                                  label: common.getTrad('No'),
                                  className: 'btn-light'
                                }
                              },
                              callback: (result) => {
                                if (result) {
                                  this.removeAllArticoli(e)
                                }
                              }
                            })
                          }}>
                          <i className="fas fa-trash"></i> {common.getTrad("Svuota la Wish List")}
                        </p>
                      </div>
                  :
                  <></>
                }
              </div>

            </div>
            <div className="tab active table-responsive" style={{padding: "0px 15px"}}>
              <table className="tabellaWishList table table-striped" style={{width: "100%"}}>
                <thead style={{background: "#fff"}}>
                  <tr>
                    <th>{common.getTrad("Marca")}</th>
                    <th className='displayArti'>{common.getTrad("Codice Articolo")}</th>
                    <th>{common.getTrad("Descrizione")}</th>
                    {this.state.isListino && (
                      <th className="gridPrice">{common.getTrad("Prezzo Unitario")}</th>
                    )}
                    <th className="gridNumber">{common.getTrad("Quantità")}</th>
                    {this.state.isListino && (
                      <th className="gridPrice">{common.getTrad("Prezzo Totale")}</th>
                    )}
                    <th className="d-print-none" style={{width: '8vw'}}></th>
                  </tr>
                </thead>
                <tbody>{
                  this.state.dataList.wishList && this.state.dataList.wishList.length > 0 ?
                    this.state.dataList.wishList.map((index, key) => {
                      let priceTotElem = ""
                      if (this.state.listinoVM.includes(index.marca)) {
                        tot += index.qpezzi * index.price;
                        let rowTot = index.price * index.qpezzi;
                        priceElem = <td className="gridPrice">{index.price.toLocaleString(localeLang, { style: 'currency', currency: index.cvalu })}</td>
                        priceTotElem = <td className="gridPrice">{rowTot.toLocaleString(localeLang, { style: 'currency', currency: index.cvalu })}</td>
                        if (firstValid === true) {
                          valuta = index.cvalu;
                          firstValid = false;
                        }
                      }
                      else if (this.state.listinoVM.length > 0) {
                        priceElem = <td className="gridPrice">N.D.</td>
                        priceTotElem = <td className="gridPrice">N.D.</td>
                      }
                      nitem += +index.qpezzi;
                      // Forzo update del value in caso di update dello state, perchè da solo non lo fa
                      $(".articoloRow_"+ index.carti.replace(/[.+-/_ ]/g,'_') + " .nuoviPezzi").val(index.qpezzi)
                      return (
                        <tr key={key} className={("animated articoloRow_"+(index.carti).replace(/[.+-/_ ]/g,'_'))}>
                          {this.state.marcheVM.map((item, keyMarca) => {
                            if(item[0] === index.marca)
                              return (<td key={keyMarca}>{item[1]}</td>)
                          })}
                          <td className='displayArti'>{index.carti}</td>
                          <td>{index.darti ? index.darti : index.dart2}
                            {index.dvari !== undefined && index.dvari !== null && index.dvari !== '' ?
                              <p dangerouslySetInnerHTML={{ __html:(index.dvari).replace(/\r?\n/g,'<br/>')}}/>
                            :
                              ""
                            }
                          </td>
                          {priceElem}
                          <td className="d-print-none gridNumber">
                            <input onChange={() => {this.changeQuantitaPezzi(index.carti)}}  type="number" name="nuoviPezzi" className="nuoviPezzi form-control" min="1" max="9999" defaultValue={index.qpezzi} style={{width: "90px",border: "1px solid"}}/>
                          </td>
                          <td className=" d-print-table-cell d-none gridNumber">{index.qpezzi}</td>
                          {priceTotElem}
                          <td className="d-print-none colonnaAzioniRigaTabellaDX mt-2">
                            {index.marca && index.modello && index.tavola ?
                              <Link to={"/draw/" + index.marca + "/" + index.modello + "/" + index.tavola} onClick={() => this.gotoTavola(index.marca, index.modello, index.tavola, index.carti)} style={{marginRight: "1.5em"}}><i title={common.getTrad("Visualizza tavola")} className="fas fa-eye text-secondary"></i></Link>
                            :
                              ""
                            }
                            <i title={common.getTrad("Cancella l'articolo")} className="fas fa-trash-alt text-secondary" style={{cursor: "pointer"}} onClick={(articolo) => {this.removeArticolo(index.carti)}}></i>
                          </td>
                        </tr>
                      )
                    })
                  :
                    <tr>
                      <td className="text-center responsiveFullWidth" colSpan="7">
                        {common.getTrad("Nessun articolo presente nel carrello")}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <hr style={{margin: '0px 15px', paddingBottom: '15px'}} />
            {this.state.dataList.wishList && this.state.dataList.wishList.length > 0 ?
              <>
                <div id="temporanyTotal" className='pt-3 pb-3 pl-3 pr-3 row'>
                  {this.state.isListino ?
                  <h5 className='col-12' style={{ padding: '5px 7px' }}>{common.getTrad("Totale provvisorio") + ": "}<strong>{tot > 0 ? tot.toLocaleString(localeLang, { style: 'currency', currency: valuta }) : '' }</strong></h5>
                  :
                  <></>
                  }
                  <p style={{ display: 'block', padding: '0 7px' }}>{common.getTrad("Articoli") + ": "}{nitem}</p>
                  {this.checkout_url ? (
                    <div>
                      <div id="borderCart" className='noStampa col-12 pl-3 pr-3 pt-4'></div>
                      <button style={{ width: '100%' }} type="button" className="btn bottone_default mb-3" onClick={(e, wishList) => { this.saveCheckout(e, this.state.dataList.wishList) }}><i className="fas fa-shopping-basket"></i> {common.getTrad("Checkout")}</button>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </>
              : <></>}
            
            <div style={{ clear: 'both' }}></div>
            
            <div className="clear"></div>
          </div>
        </div>
      )
  }
}

const mapStateToProps = state => {
  const store = wishListSelector(state);
  return { store };
}
export default connect(mapStateToProps, { changeFilter, changeDatalist, changeMutex, setNewUrlState, changeValues })(WishList);
//export default WishList;


export function in_WishList(articolo){
  if(articolo === null || typeof articolo !== 'object')
    return -1;

  let state = store.getState();
  for (var i=0; i<state.dataList.wishList.length;  i++)
    if (state.dataList.wishList[i].carti === articolo.CARTI || state.dataList.wishList[i].carti === articolo.carti || state.dataList.wishList[i].cartiSost === articolo.CARTI) //Usare sempre il maiuscolo era troppo facile....
      return i;

  return -1;
}
